import localeDataset from '@wix/locale-dataset-javascript';
import { useTranslation } from '../contexts/translation-context';
import { useCountryCode } from '../fields/multiline-address/multiline-address/country-code-context';
export function useAddressLabel(addressPart) {
  const {
    t
  } = useTranslation();
  const countryCode = useCountryCode();
  const country = countryCode && localeDataset.getCountryByShortKey(countryCode);
  const addressKeys = country ? country.addressPartDisplayNames : localeDataset.getDefaultAddressDisplayNames();
  const labelKey = addressKeys[addressPart];
  const label = labelKey ? t(labelKey) : '';
  return label;
}
//# sourceMappingURL=use-address-label.js.map